export default "__VITE_ASSET__BCDnu258__"